import { PatientTransactionItemType } from '@chiroup/core';
import EncounterBillingView from './EncounterBillingView';
import { useTotals } from '../hooks/useTotals';

type Props = {
  patientResponsibility?: string;
  payorsResponsibility: { [key: string]: { amount: string; name: string } };
  servicesTotal: number;
  treatmentId?: number;
  disciplineId?: number;
  appointmentServices?: Partial<PatientTransactionItemType>[];
  treatmentName?: string;
};

const EncounterBillingSummary: React.FC<Props> = ({
  patientResponsibility,
  payorsResponsibility,
  servicesTotal,
  treatmentId,
  disciplineId,
  appointmentServices = [],
  treatmentName,
}) => {
  const { totalTax, total, subTotal } = useTotals({
    appointmentServices,
    treatmentId: treatmentId ?? 0,
    disciplineId: disciplineId ?? 0,
    servicesTotal,
  });

  return (
    <>
      <hr className="my-4" />
      <div className="relative flex justify-between items-center mb-4">
        <div className="text-lg text-primary-600 font-medium leading-5">
          Estimated Responsibility
        </div>
      </div>
      <EncounterBillingView
        subTotal={subTotal}
        total={total}
        tax={totalTax}
        treatmentName={treatmentName ?? ''}
        payorsResponsibility={payorsResponsibility}
        patientResponsibility={Number(patientResponsibility)}
        showResponsibility
      />
    </>
  );
};

export default EncounterBillingSummary;
